import "./Profile.scss";

import Profile from "./Profile";

export default Profile;
